var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c(
        "Modal",
        {
          staticClass: "page-modal",
          attrs: {
            width: "40%",
            "mask-closable": false,
            "footer-hide": true,
            title: _vm.$t("openConfig.addName"),
            "class-name": "vertical-center-modal",
          },
          model: {
            value: _vm.dialogVisible,
            callback: function ($$v) {
              _vm.dialogVisible = $$v
            },
            expression: "dialogVisible",
          },
        },
        [
          _c(
            "div",
            { staticClass: "modalContainer" },
            [
              _c(
                "Form",
                {
                  ref: "addForm",
                  attrs: {
                    "label-width": 130,
                    model: _vm.addForm,
                    "label-colon": "",
                    rules: _vm.ruleValidate,
                  },
                },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        label: _vm.$t("openConfig.devType"),
                        prop: "devType",
                      },
                    },
                    [
                      _c(
                        "Select",
                        {
                          attrs: {
                            size: "large",
                            placeholder: _vm.$t("openConfig.devTypeTip"),
                          },
                          model: {
                            value: _vm.addForm.devType,
                            callback: function ($$v) {
                              _vm.$set(_vm.addForm, "devType", $$v)
                            },
                            expression: "addForm.devType",
                          },
                        },
                        _vm._l(_vm.devTypeList, function (item, index) {
                          return _c(
                            "Option",
                            { key: index, attrs: { value: item.value } },
                            [_vm._v(_vm._s(item.name))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "FormItem",
                    {
                      attrs: { label: _vm.$t("openConfig.room"), prop: "room" },
                    },
                    [
                      _c("Input", {
                        attrs: {
                          size: "large",
                          maxlength: 24,
                          placeholder: _vm.$t("openConfig.roomTip"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.addForm.room,
                          callback: function ($$v) {
                            _vm.$set(_vm.addForm, "room", $$v)
                          },
                          expression: "addForm.room",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "FormItem",
                    {
                      attrs: { label: _vm.$t("openConfig.name"), prop: "name" },
                    },
                    [
                      _c("Input", {
                        attrs: {
                          size: "large",
                          maxlength: 10,
                          placeholder: _vm.$t("openConfig.nameTip"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.addForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.addForm, "name", $$v)
                          },
                          expression: "addForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "FormItem",
                    { attrs: { label: _vm.$t("openConfig.pic") } },
                    [
                      _c("form", { attrs: { id: "uploadImg" } }, [
                        _c("div", { staticClass: "img-box" }, [
                          _vm.facePicUrl !== ""
                            ? _c(
                                "div",
                                {
                                  staticClass: "img-item",
                                  class: {
                                    "form-box-margin": _vm.facePicUrl !== "",
                                  },
                                },
                                [
                                  _c(
                                    "Badge",
                                    [
                                      _c("div", { staticClass: "url-box" }, [
                                        _c("img", {
                                          staticClass: "url-img",
                                          attrs: { src: _vm.facePicUrl },
                                        }),
                                      ]),
                                      _c("Icon", {
                                        staticClass: "close-badge",
                                        attrs: {
                                          slot: "count",
                                          type: "md-remove-circle",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.delImg(_vm.index)
                                          },
                                        },
                                        slot: "count",
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.facePicUrl === "",
                                  expression: "facePicUrl === ''",
                                },
                              ],
                              staticClass: "img-item",
                            },
                            [
                              _c("div", { staticClass: "form-box" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "file",
                                    attrs: { href: "javascript:;" },
                                  },
                                  [
                                    _c("Icon", {
                                      staticClass: "add-icon",
                                      attrs: { type: "md-add" },
                                    }),
                                    _c("input", {
                                      attrs: {
                                        type: "file",
                                        name: "facePic",
                                        accept: ".jpg,.png,.jpeg",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.showPic($event)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "detailBackBtn" },
            [
              _c(
                "Button",
                { attrs: { size: "large" }, on: { click: _vm.closeModal } },
                [_vm._v(_vm._s(_vm.$t("common.cancel")))]
              ),
              _c(
                "Button",
                {
                  attrs: { type: "primary", size: "large" },
                  on: { click: _vm.addNameSingle },
                },
                [_vm._v(_vm._s(_vm.$t("common.ensure")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c("div", { staticClass: "content_win" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }